import { graphql } from 'react-relay';

export const fundsIntroductionFragment = graphql`
    fragment FundsIntroduction_component on FundsIntroduction {
        title
        shorttext
        longtext
        warning
    }
`;
